import React from 'react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../assets/css/modal.css'
function Confirmation(props) {

  const [reason, setReason] = useState("");
  return (
    <>
      <div className="">
        <Modal.Header onClick={() => props.onHide(false)} className="Confirmation-Modal-H" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className='ff_pop fs-15 text-center'>
            {props.msg}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className='offcan_yes_button yes_btn_conf' onClick={() => props.responseconfirmation(true,reason)}>Yes</button>
          <button className='offcan_no_button no_btn_conf' onClick={() => props.onHide()}>No</button>
          {
            props.reasonBox === true ?
              <textarea rows="4" cols="40" placeholder='Reject Reason(Mandatory)' className='px-1 fs-13' onChange={(e)=>setReason(e.target.value)}></textarea> : <></>
          }
        </Modal.Footer>
      </div>
    </>

  )
}
export default Confirmation;